import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatApiErrorDetail } from "@/lib/api";

const WORD = "LÖSCHEN";

// Shared confirmation: password (or e-mail for Google accounts) + typing LÖSCHEN.
export const DeleteAccountDialog = ({ open, onOpenChange, title, description, passwordLabel, onConfirm }) => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const ready = password && confirm.trim() === WORD;

  const close = (v) => {
    if (!v) {
      setPassword("");
      setConfirm("");
    }
    onOpenChange(v);
  };

  const submit = async () => {
    setBusy(true);
    try {
      await onConfirm({ password, confirm: confirm.trim() });
      close(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid="delete-account-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <Trash2 className="h-5 w-5" /> {title}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="del-pw">{passwordLabel}</Label>
            <Input id="del-pw" type="password" autoComplete="current-password" value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="delete-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="del-confirm">Zur Bestätigung „{WORD}“ eingeben</Label>
            <Input id="del-confirm" value={confirm} placeholder={WORD}
              onChange={(e) => setConfirm(e.target.value)} data-testid="delete-confirm-input" />
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => close(false)} data-testid="delete-cancel-btn">Abbrechen</Button>
          <Button variant="destructive" disabled={!ready || busy} onClick={submit} data-testid="delete-submit-btn">
            {busy ? "Wird gelöscht…" : "Endgültig löschen"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
